<script lang="ts">
  import FooterButtons from "../../../components/workflow/FooterButtons.svelte";
  import CloseButton from "../../../components/CloseButton.svelte";

  let {
    url,
    phone,
  }: {
    url: string;
    phone: string;
  } = $props();
</script>

<h2 class="ui-title">First, provide your ID</h2>

<p>
  To complete payment, we need up-to-date identification documents matching your
  current name and address.
</p>
<p>
  <a class="underline text-blue-500" href={url} data-turbo-frame="task-modal">Upload identification</a>
  or call us at <a class="underline text-blue-500" href="tel:{phone}">{phone}</a> if you need assistance.
</p>

<div class="pt-20"></div>
<FooterButtons back={false}>
  <CloseButton />
  <a class="btn btn-primary" href={url} data-turbo-frame="task-modal">Upload identification</a>
</FooterButtons>
